
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';

import { WorldTravelNews } from '../../models/information/news.models';
import { DialogService } from '../../shared/services/dialog.service';
import { InformationService } from './information.service';

@Component({
    selector: 'news-memo-popup',
    templateUrl: 'world-travel.popup.component.html',
    providers: [InformationService]
})

export class WorldTravelPopUpComponent implements OnInit {
    // modifyNewPopupForm: FormGroup;
    id: any;
    public news: WorldTravelNews;
    public url: string;
    public isConfirm;
    constructor(
        public dialogRef: MatDialogRef<WorldTravelPopUpComponent>,
        public dialogService: DialogService,
        public informationService: InformationService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        if (this.data) {
            this.news = this.data.news;
        }
        // this.newsDetailService.getNewsDetailData(this.data.id).subscribe(
        //     result=>{
        //         if(result){
        //             const data = result.json();
        //             this.arr = data;
        //         }
        //     }
        // );
        this.informationService.downloadFile(this.data.id).subscribe(
            result => {
                if (result) {
                    this.url = result.url;
                }
                else {
                    this.url = "";
                }
            }
        );
    }


    close() {
        this.dialogRef.close(this.isConfirm);
    }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/information/world-travel-detail.popup.component.ts